import { ContentPage, db, DBEntity } from "../db";
import { auditEntity } from "../helpers";

export const pagesRepository = {
  put: (page: ContentPage) => {
    auditEntity(page);
    return db.pages.put(page);
  },
};
